import React, { useEffect, useState } from 'react';
import { Button,Container, IconButton, Grid, FormGroup, TextField, Typography, FormHelperText,FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal } from '@mui/material';
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import { Delete, Add } from "@mui/icons-material";
import api from './api'; // api.js をインポート
import PdfModalViewer from './PdfModalViewer.js';
import { useConfirmBackLogout } from './common/useConfirmBackLogout.js';
import { useNavigationHistory } from './common/navigationHistory.js';
import BackButton from './common/BackButton.js';
import HamburgerMenu from './components/Hamburger.jsx';
import Header from "./components/Header.jsx";

const Comp18Sub = ({
  changeModalOpen,
  exhibitorId: propExhibitorId,
  isModal=false,
  isCorpModal=false,
  setFormModalOpen,
  selectedFormKey,
  setExhibitors
}) => {
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null); 
  const [mypageData, setMypageData] = useState(null);
  const [sameAsExhibitor, setSameAsExhibitor] = useState("different");
  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
      // 出展者情報コピー
      setFormData((prev) => ({
        ...prev,
        user_18_name: mypageData.user_name || "",
        user_18_department: mypageData.department || "",
        user_18_phone: mypageData.phone_number || "",
        user_18_tel: mypageData.tel_number || "",
      }));
      setFieldsDisabled(true);
    } else if (value === "different") {
      // フィールドを空にする
      setFormData((prev) => ({
        ...prev,
        user_18_name: "",
        user_18_department: "",
        user_18_phone: "",
        user_18_tel: "",
      }));
      setFieldsDisabled(false);
    }
  };
  const navigate = useNavigate();
  const location = useLocation();
  const handleScrollTo = (id, targetUrl) => {
    if (targetUrl && window.location.pathname !== targetUrl) {
      // 別ページなら localStorage に保存して navigate
      localStorage.setItem('scrollToId', id);
      navigate(targetUrl);
    } else {
      // 同ページなら即スクロール
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };
  const [formData, setFormData] = useState({
    user_18_name: "",
    user_18_department: "",
    user_18_phone: "",
    user_18_tel: "",
    catchphrase: "",
    basic_structure: false,
    basic_chair: false,
    side_panel: false,
    additional_certs: 0,
    alfa_text: "",
  });
  const [corrections, setCorrections] = useState({
    user_18_info: false,
    catchphrase: false,
  });
  const field_name_map = {
    user_18_info: "担当者情報",
    catchphrase: "キャッチコピー",
  };
  const [open, setOpen] = useState(false);
  const [memoText, setMemoText] = useState('');
  const handleCorrectionChange = (fieldKey) => (e) => {
    setCorrections((prev) => ({
      ...prev,
      [fieldKey]: e.target.checked,
    }));
  };
  const updateStatus = (exhibitorId, formType, updates) => {
    setExhibitors((prev) =>
      prev.map((ex) =>
        ex.exhibitor_id === exhibitorId
          ? {
              ...ex,
              ...Object.fromEntries(
                Object.entries(updates).map(([role, status]) => [
                  `${formType}_${role}_status`,
                  status,
                ])
              ),
            }
          : ex
      )
    );
  };
  const updateCorporateStatus = (exhibitorId, formType, action) => {
    setExhibitors((prev) =>
      prev.map((ex) => {
        if (ex.exhibitor_id !== exhibitorId) return ex;

        if (action === 'confirm') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '確認済',
            [`${formType}_host_status`]: '確認済',
          };
        }

        if (action === 'correction') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '未確認',
            [`${formType}_host_status`]: '未確認',
            [`${formType}_exhibitor_status`]: '再提出',
          };
        }

        return ex;
      })
    );
  };
  const handleCorrection = async () => {
    try {
      const res = await api.patch('/api/forms/correction', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'correction');

      alert('再提出に更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('再提出処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };
  const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'確認済');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };
  useEffect(() => {
    if ((isModal || isCorpModal) && propExhibitorId) {
      setExhibitorId(propExhibitorId);
      return;
    }

    const userData = localStorage.getItem("user");

    if (userData) {
      const parsedUser = JSON.parse(userData);
      if (parsedUser?.exhibitor_id) {
        setExhibitorId(parsedUser.exhibitor_id);
      } else {
        console.warn("exhibitor_id が見つかりません");
      }
    } else {
      console.warn("localStorageにuserが存在しません");
    }
  }, [location, isModal, isCorpModal, propExhibitorId]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);
  const [isHovered, setIsHovered] = useState(false);
  const pdfItems = [
    // { label: 'INDEX', path: '/INDEX.pdf' },
    { label: '出展規定', path: '/出展規定.pdf' },
      { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
      { label: '色見本', path: '/色見本.pdf' },
      { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
      { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
      { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
  ];
  const renderMenuItems = () => (
    <div
        className="menu-item"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
    >
        <div className="menu-label">資料ダウンロード</div>
        {isHovered && (
        <div className="submenu">
            {pdfItems.map((item, index) => (
            <a key={index} href={item.path} download className="submenu-item">
                {item.label}
            </a>
            ))}
        </div>
        )}
    </div>
  );
  useEffect(() => {
  const fetchR18InitialData = async () => {
      try {
      const user = JSON.parse(localStorage.getItem("user"));

      const [resStatus, resR18, resMypage] = await Promise.all([
          api.get(`/api/submission-status/${exhibitorId}`),
          api.get(`/api/r18submission/${exhibitorId}`),
          api.get(`/api/mypage/${exhibitorId}`)
      ]);

      const r18Status = resStatus.data?.r18_status || "";
      const r18Data = resR18.data || {};
      const mypage = resMypage.data || {};

      if (Object.values(r18Data).some(v => {
      if (Array.isArray(v)) return v.length > 0;
      return v !== "" && v !== null && v !== undefined;
      })) {
      setFormData(prev => ({
          ...prev,
          ...r18Data,
      }));
      if (
        r18Data.user_18_name === mypage.user_name &&
        r18Data.user_18_department === mypage.department &&
        r18Data.user_18_phone === mypage.phone_number &&
        r18Data.user_18_tel === mypage.tel_number
      ) {
        setSameAsExhibitor("same");
        setFieldsDisabled(true);
      } else {
        setFieldsDisabled(false);
      }
      }

      } catch (err) {
      console.error("R18初期データ取得エラー:", err);
      }
    };

  fetchR18InitialData();
  }, []);
  const [submitErrors, setSubmitErrors] = useState({});
  const handleSubmit = async () => {
    try {
      if (!exhibitorId || typeof exhibitorId !== "number") {
        alert("exhibitorId が不正です");
        return;
      }

      const submitErrors = {};
      const catchphrase = (formData?.catchphrase || "").trim();

      if (!catchphrase) {
        submitErrors.catchphrase = "入力してください";
      } else if (catchphrase.length > 20) {
        submitErrors.catchphrase = "20文字以内で入力してください";
      }
      const allErrors = submitErrors;

      if (Object.keys(allErrors).length > 0) {
        setSubmitErrors(submitErrors);
        window.scrollTo({ top: 0, behavior: "smooth" });

        const fieldDisplayNames = {
          user_18_name: "担当者名",
          user_18_department: "担当部署",
          user_18_phone: "担当者携帯",
          user_18_tel: "担当者電話",
          catchphrase: "キャッチコピー",
          additional_certs: '追加出展者証',
        };

        const errorMessages = Object.entries(submitErrors)
          .map(
            ([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`
          )
          .join("\n");

        alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
        return;
      }

      const payload = {
        exhibitor_id: exhibitorId,
        formData: formData,
      };

      const res = await api.post("/api/submit-r18", payload);
      
      if (res.status === 200) {
        alert("保存成功");
      } else {
        alert("保存失敗");
      }

      setTimeout(() => {
        if (isModal) {
          setFormModalOpen(false);
        } else {
          if (user?.user_id === 0) {
            navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
          } else {
            navigate(`/mypage/${user?.mypage_id}`);
          }
        }
      }, 1000);
    } catch (err) {
      console.error(err);
      alert("エラー");
    }
  };
  const handleChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };
  const handleCatchRadio = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value === "true" });
  };

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  const user = JSON.parse(localStorage.getItem("user"));
    useConfirmBackLogout(navigate);
    useNavigationHistory();
  const baseUrl =
  window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8000'          // ローカル開発用
    : 'https://sdgs.ex-link.net'; // 本番 HTTPS

  return (
    <>
    <div sx={{mx: 0, px: 0 , width: '100%'}}>
    {!isCorpModal &&(
      <Header
        title="SDGs 子ども・ユースフェア2026 防炎対象物品申請"
        companyName={mypageData?.company_name}
      />
    )}
    <style>
    {`
    @media only screen and (max-width: 560px) {
    .sm-block {display: block;}
    .sm-none {display: none;}
    .sm-column {flex-direction: column;}
    .noti-cate {font-size: 18px;}
    .timestamp {font-size: 14px;}
    .info {font-size: 14px;}
    .f-16 {font-size: 16px;}
    }
    @media only screen and (min-width: 561px) {
    .hamburger_menu_btn_wrap {display: none;}
    }
    `}
    </style>
    <Container sx={{ display: 'flex' }}>
      {!isCorpModal &&(
      <>
      <Container sx={{ width: '22%', mt: 4 }} className="sm-none">
        <Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box
              className={`menu-item`}
              onClick={() => {
                const user = JSON.parse(localStorage.getItem('user'));
                navigate(`${user?.mypage_url}`);
              }}
            >
              TOP
            </Box>
            <Box 
              className="menu-item"
              onClick={() => {
                const user = JSON.parse(localStorage.getItem('user'));
                navigate(`/mypage-info/${user?.exhibitor_id}`);
              }}
            >
              出展者情報編集
            </Box>
            <Box 
              className="menu-item"
              onClick={() => {
                navigate('/mail-form/');
              }}
            >
              お問い合わせ
            </Box>
            {renderMenuItems()}
            <Box 
              className="menu-item"
              onClick={() => {
                const user = JSON.parse(localStorage.getItem('user') || '{}');
                const mypage = user?.mypage_url;

                handleScrollTo('news', mypage);
              }}
            >
              お知らせ
            </Box>
            <Box
              className="menu-item"
              onClick={() => window.open('https://sdgs-aichi.com/privacy/index.html', '_blank', 'noopener,noreferrer')}
            >
              個人情報保護方針
            </Box>
          </Box>
        </Box>
        <BackButton />
      </Container>
      <HamburgerMenu />
      </>
      )}
      {!!changeModalOpen &&(
        <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
          <Typography variant="h6" gutterBottom>
            修正内容のメモ
          </Typography>
          <TextField
            multiline
            rows={20}
            fullWidth
            placeholder="ここに修正内容を書いてください..."
            value={memoText}
            onChange={(e) => setMemoText(e.target.value)}
          />
          <Box>
            <Typography variant="h6">マイページ情報</Typography>
            {mypageData ? (
              <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                <Typography variant="body1">部署: {mypageData.department}</Typography>
                <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                <Typography variant="body1">住所: {mypageData.address}</Typography>
                <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
              </Box>
            ) : (
              <Typography variant="body2">読み込み中...</Typography>
            )}
          </Box>
        </Box>
      )}
      <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
        <Box sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>

          <Typography variant="h6" gutterBottom className="f-18">
            キャッチコピー・ブース変更届
          </Typography>

          <Grid sx={{ p: { xs: 0, md: 2 } }}>
            {!!changeModalOpen &&(
              <FormControlLabel
                control={
                  <Checkbox
                    checked={corrections.user_18_info}
                    onChange={handleCorrectionChange("user_18_info")}
                    sx={{
                color: 'red', // 未チェック時の枠の色
                '&.Mui-checked': {
                  color: 'red', // チェック時の色
                },
              }}
                  />
                }
                label="担当者情報"
              />
            )}
            <Typography variant="h6" gutterBottom>
            担当者情報
            </Typography>
            <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Grid container spacing={2}>
            <Grid size={6}><TextField fullWidth label="氏名" name="user_18_name" value={formData?.user_18_name} disabled={fieldsDisabled} onChange={handleChange("user_18_name")} error={!!submitErrors.user_18_name} helperText={submitErrors.user_18_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
            <Grid size={6}><TextField fullWidth label="部署" name="user_18_department" value={formData?.user_18_department} disabled={fieldsDisabled} onChange={handleChange("user_18_department")} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
            <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_18_phone" value={formData?.user_18_phone} disabled={fieldsDisabled} onChange={handleChange("user_18_phone")} error={!!submitErrors.user_18_phone} helperText={submitErrors.user_18_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
            <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_18_tel" value={formData?.user_18_tel} disabled={fieldsDisabled} onChange={handleChange("user_18_tel")} error={!!submitErrors.user_18_tel} helperText={submitErrors.user_18_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
            </Grid>
            <Typography color="error">※ご連絡可能な電話番号をご入力ください。</Typography>
            <Typography variant='h6' className='f-18'>出展者証の追加</Typography>
            <TextField
              label="追加枚数を記載して下さい。"
              name="additional_certs"
              value={formData.additional_certs}
              onChange={handleChange("additional_certs")}
              fullWidth
              sx={{ mb: 2 }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Box>
                <Typography>例</Typography>

                <img
                style={{ width: 250 }}
                src="/add_cert.png"
                alt="出展者証見本"
                />
            </Box>
            {!!changeModalOpen && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={corrections.catchphrase}
                    onChange={handleCorrectionChange("catchphrase")}
                    sx={{ color: "red", "&.Mui-checked": { color: "red" } }}
                  />
                }
                label="キャッチコピー"
              />
            )}
            <Typography variant="h6" className="f-18">
                キャッチコピー登録
            </Typography>

            <TextField
                label="キャッチコピー（20文字まで）"
                name="catchphrase"
                value={formData?.catchphrase}
                onChange={handleChange("catchphrase")}
                error={
                formData?.catchphrase &&
                formData?.catchphrase.length > 20
                }
                helperText={
                formData?.catchphrase &&
                formData?.catchphrase.length > 20
                    ? "20文字以内で入力してください"
                    : ""
                }
                sx={{ mb: 2 }}
                fullWidth
            /> 
            <Typography color='error'>※キャッチコピーは20文字までとなります。</Typography>       
            <Box>
                <Typography>例</Typography>

                <img
                style={{ width: "100%" }}
                src="/catch.jpg"
                alt="キャッチコピー例"
                />
            </Box>
            
            <Box sx={{ display: 'flex', mt: 2 }} className="sp-column">
              {mypageData?.booth_form !== "シマ" && (
              <>
              <FormControl>
                <FormLabel>長机</FormLabel>
                <RadioGroup
                  row
                  name="basic_structure"
                  value={formData?.basic_structure?.toString() ?? ""}
                  onChange={handleCatchRadio}
                >
                  <FormControlLabel value="true" control={<Radio />} label="使用する" />
                  <FormControlLabel value="false" control={<Radio />} label="使用しない" />
                </RadioGroup>
              </FormControl>

              <FormControl>
                <FormLabel>パイプ椅子</FormLabel>
                <RadioGroup
                  row
                  name="basic_chair"
                  value={formData?.basic_chair?.toString() ?? ""}
                  onChange={handleCatchRadio}
                >
                  <FormControlLabel value="true" control={<Radio />} label="使用する" />
                  <FormControlLabel value="false" control={<Radio />} label="使用しない" />
                </RadioGroup>
              </FormControl>
              </>
              )}

              {mypageData?.booth_corner && (
                <FormControl>
                  <FormLabel>側面パネル</FormLabel>
                  <RadioGroup
                    row
                    name="side_panel"
                    value={formData?.side_panel?.toString() ?? ""}
                    onChange={handleCatchRadio}
                  >
                    <FormControlLabel value="true" control={<Radio />} label="使用する" />
                    <FormControlLabel value="false" control={<Radio />} label="使用しない" />
                  </RadioGroup>
                </FormControl>
              )}
            </Box>
          </Grid>
          <Box sx={{ mt: 3 }}>
            <TextField fullWidth multiline minRows={4} label="備考" value={formData?.alfa_text || ""} onChange={handleChange("alfa_text")} />
          </Box>
        </Box>
        <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
          <Typography className='info'>
            【上記入力内容についてのお問い合わせ先】<br />
            SDGs 子ども・ユースフェア2026企画運営室（中部経済新聞社 事業部内）<br />
            担当：中島、佐野<br />
            TEL:052-561-5675<br />
            入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
            ※お急ぎの場合はお電話にてお問い合わせください。
          </Typography>
        </Box>
      </Container>
    </Container>
    {!isCorpModal &&(
    <>
    <Container sx={{textAlign: 'center'}}>
        <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
            提出する
        </Button>
    </Container>
    <footer>
      <Typography>
        © 2026 THE MID-JAPAN ECONOMIST.
      </Typography>
    </footer>
    </>
    )}
    {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button 
          variant="contained" 
          color="error" 
          onClick={handleCorrection}
          disabled={memoText.trim() === ''}
        >
          修正
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          確認
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
    </>
  );
};

export default Comp18Sub;
